import { createContext, useContext } from "react";
import { makeProvider } from "../helpers/makeContexts";

const init = {
    isFullPage: false
};

function reducer(draft, { type, payload }) {
    switch (type) {
      case "setFullPage": {
        draft.isFullPage = payload;
        break;
      }
      default: {
        return null;
      }
    }
}

const [Context, Dispatch] = [
    createContext(null),
    createContext(null),
  ];
  
  export const FullPageProvider = makeProvider(Context, Dispatch, reducer, init);
  
  export function useFullPage() {
    return useContext(Context);
  }
  
  export function useFullPageDispatch() {
    return useContext(Dispatch);
  }

export function RemoveOnFullPage({ children }) {
    const { isFullPage } = useFullPage();

    if (isFullPage) return null;

    return (
        <>
            {children}
        </>
    )
}